import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { signInWithCustomToken, signInWithPopup, signOut, user, Auth, GoogleAuthProvider, getIdToken } from '@angular/fire/auth';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Session {
  email: string;
  token: string;
  verified: boolean;
}

@Injectable({ providedIn: 'root' })
export class SessionsService {
  constructor(
    private auth: Auth,
    private http: HttpClient,
  ) {}
  
  async signIn(): Promise<void> {
    const { user } = await signInWithPopup(this.auth, new GoogleAuthProvider());
    const token = await getIdToken(user);
    const { token: newToken } = await firstValueFrom(this.http.post<{ token: string }>(`${environment.apiUrl}/sessions`, null, { headers: { 'Authorization': `Bearer ${token}` } }));
    await signInWithCustomToken(this.auth, newToken);
  }

  signOut(): Promise<void> {
    return signOut(this.auth);
  }

  getSessionToken(): Promise<Session | null> {
    return firstValueFrom(user(this.auth)).then(async (user) => {
      if (user) {
        const idToken = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        if (idTokenResult.claims['email'] && idTokenResult.claims['verified']) {
          return {
            email: idTokenResult.claims['email'] as string,
            token: idToken,
            verified: idTokenResult.claims['verified'] as boolean,
          };
        }
      }
      return null;
    });
  }
}
